import { render, staticRenderFns } from "./bannercompetitions.vue?vue&type=template&id=55534ff0"
import script from "./bannercompetitions.vue?vue&type=script&lang=js"
export * from "./bannercompetitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports